import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IntegrationDetailPage } from '@/pages/integrations/detail/IntegrationDetailPage'
import { parseProviderIntegrationSearch } from '@/pages/integrations/detail/integration-detail-search'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug'
)({
  validateSearch: parseProviderIntegrationSearch,
  component: ProviderIntegrationDetailRoute,
  staticData: {
    pageHeader: { title: 'Integration', customHeader: true, pad: false },
  },
})

function ProviderIntegrationDetailRoute() {
  const { workspaceId, auditCycleId, providerSlug } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <IntegrationDetailPage
      workspaceId={workspaceId}
      auditCycleId={auditCycleId}
      providerSlug={providerSlug}
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    />
  )
}
